import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { useDayjs } from 'hooks/useDayjs'
import { TbRefresh } from 'react-icons/tb'
import { IconButton } from './IconButton'

export type RefetchButtonProps = Partial<
  Pick<UseQueryResult, 'refetch' | 'dataUpdatedAt' | 'isFetching'>
>

export const RefetchButton = ({
  refetch,
  dataUpdatedAt,
  isFetching,
}: RefetchButtonProps) => {
  const dayjs = useDayjs()
  const { data: lastUpdatedAt } = useQuery({
    queryKey: ['lastUpdatedAt', 'rawPacketTable'],
    queryFn: () => (dataUpdatedAt ? dayjs(dataUpdatedAt).fromNow() : null),
    refetchInterval: 5 * 1000,
  })

  if (refetch && lastUpdatedAt)
    return (
      <IconButton
        onClick={() => refetch()}
        icon={TbRefresh}
        label={`Last updated: ${lastUpdatedAt}`}
        loading={isFetching}
      />
    )

  return null
}
